export const normalizeMessages = (state, messages) =>
  messages.reduce(
    (acc, message) => ({
      byId: {
        ...acc.byId,
        [message.messageId]: message,
      },
      allIds: acc.allIds.includes(message.messageId)
        ? acc.allIds
        : [...acc.allIds, message.messageId],
      byChatId: [...acc.byChatId, message.messageId],
    }),
    { byId: state.messages.byId, allIds: state.messages.allIds, byChatId: [] },
  );
